// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { LoginResponseFragmentDoc } from '../auth/fragments/loginResponse.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateCustomerThroughQuestionnaireWithoutQuestionnaireDocument = gql`
    mutation createCustomerThroughQuestionnaireWithoutQuestionnaire($input: CustomerRegistrationInput!, $type: QuestionnaireType!, $questionnaireSourceUrl: Uri, $isConsultant: Boolean!, $locale: Locale!) {
  createCustomerThroughQuestionnaireWithoutQuestionnaire(
    type: $type
    input: $input
    questionnaireSourceUrl: $questionnaireSourceUrl
  ) {
    __typename
    login {
      ...loginResponse
    }
  }
}
    ${LoginResponseFragmentDoc}`;

export function useCreateCustomerThroughQuestionnaireWithoutQuestionnaireMutation() {
  return Urql.useMutation<SchemaTypes.CreateCustomerThroughQuestionnaireWithoutQuestionnaireMutation, SchemaTypes.CreateCustomerThroughQuestionnaireWithoutQuestionnaireMutationVariables>(CreateCustomerThroughQuestionnaireWithoutQuestionnaireDocument);
};